<template>
  <div>
    <ModalBasic
      v-if="modal_show.impressum"
      @close="close('impressum')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1">
          Impressum
        </h1>
      </template>
      <template v-slot:body>
        <Impressum />
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('impressum')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>

    <ModalBasic
      v-if="modal_show.privacy"
      @close="close('privacy')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1">
          Datenschutzerklärung
        </h1>
      </template>
      <template v-slot:body>
        <PrivacyPolicy />
      </template>

      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('privacy')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>


    <ModalBasic
      v-if="modal_show.cookie_banner"
      @close="close('cookie_banner')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1" style="font-size: 21px;">
          Wir verwenden Cookies
        </h1>
      </template>
      <template v-slot:body>
        <CookieDialog @close="close('cookie_banner')" />
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('cookie_banner')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>


    <MainTopNavBar />

    <header>
      <div class="container">
        <div class="row">
          <div class="col-xs-6">
            <h1 style="display:none;">
              gårdsfabriken - Webentwicklung
            </h1>
          </div>
        </div>

        <div class="row header-info">
          <div class="col-sm-10 col-sm-offset-1 text-center">
            <h3 class="wow fadeIn">
              <img
                class="webhosting_img"
                alt="gårdsfabriken webhosting"
                src="img/webhosting-entwicklung.png"
                style="margin-bottom: 70px"
              >
            </h3>
            <p
              class="lead wow fadeIn"
              data-wow-delay="0.5s"
            >
              Ich bringe Ihre Ideen online,
              <br>ganz nach Ihren Wünschen.
            </p>
            <br>

            <div class="row">
              <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                <div class="row">
                  <div
                    class="col-xs-6 text-right wow fadeInUp"
                    data-wow-delay="1s"
                  >
                    <a
                      href="#be-the-first"
                      class="btn btn-secondary btn-lg scroll"
                    >Mehr erfahren</a>
                  </div>
                  <div
                    class="col-xs-6 text-left wow fadeInUp"
                    data-wow-delay="1.4s"
                  >
                    <a
                      href="#invite"
                      class="btn btn-primary btn-lg scroll"
                    >Kontakt</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="mouse-icon hidden-xs">
      <div class="scroll" />
    </div>

<section
      id="be-the-first"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="0.6s"
          >
            <h2>Mein Angebot</h2>
            <p
              class="lead"
            >
              Für Start-Ups, Freelancer, Kleinunternehmen, sowie auch Schulen, Lehrkräfte und andere kreative Köpfe.
            </p>
          </div>
        </div>

        <div
          class="iphone wow fadeInUp"
          data-wow-delay="1s"
        >
          <img src="img/apple-family.png">
        </div>
      </div>
    </section>
    <section
      id="main-info"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 text-center margin-30">
            <p class="lead">
              Sie haben ein kleines Programm, eine Demonstrationsanwendung, ein Lernspiel oder etwas Ähnliches? 
              Um es zur Verfügung zu stellen, möchten Sie es als Webseite oder Webanwendung online bringen? 
              <strong>Kein Problem!</strong> Ich biete Ihnen die professionelle Umsetzung Ihrer Idee.
            </p>
            
          </div>
          
        </div>

        <div class="row">
          <!-- DevOps & Engineering -->
          <div class="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
            <hr class="line green-light ">
            <h3 class="text-center">
              <i class="fa fa-cogs dev-bullets" aria-hidden="true" />
              DevOps & Engineering
            </h3>
            <ul class="list-unstyled small">
              <li><strong>Container & Orchestrierung:</strong> Docker, Docker-Compose, AWS</li>
              <li><strong>CI/CD:</strong> GitHub Actions, GitLab CI</li>
              <li><strong>IaC:</strong> Terraform (AWS)</li>
              <li><strong>Streaming:</strong> RabbitMQ, Kafka</li>
              <li><strong>Cloud:</strong> AWS (EC2, RSConnect), Colab</li>
              <li><strong>Testautomation:</strong> Selenium, PyTest, End2End</li>
              <li><strong>Monitoring:</strong> Testkonzepte & Qualitätssicherung</li>
            </ul>
          </div>

          <!-- KI / AI & Machine Learning -->
          <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
            <hr class="line green-dark">
            <h3 class="text-center">
              <i class="fa fa-lightbulb-o dev-bullets" aria-hidden="true" />
              KI / AI & Machine Learning
            </h3>
            <ul class="list-unstyled small">
              <li><strong>Computer Vision:</strong> YOLOv5, FastAPI Deployment</li>
              <li><strong>NLP:</strong> Spacy, HuggingFace, Search & REST</li>
              <li><strong>Zeitreihen:</strong> MCMC-basiertes Forecasting (R)</li>
              <li><strong>ML-Tooling:</strong> Scikit-Learn, PyUnit, Colab</li>
              <li><strong>Preprocessing:</strong> TIKA, Tesseract, Image Processing</li>
            </ul>
          </div>

          <!-- Full-Stack & Softwareentwicklung -->
          <div class="col-sm-6 wow fadeIn" data-wow-delay="0.6s">
            <hr class="line green-very-dark">
            <h3 class="text-center">
              <i class="fa fa-server dev-bullets" aria-hidden="true" />
              Full-Stack & Softwareentwicklung
            </h3>
            <ul class="list-unstyled small">
              <li><strong>Backend:</strong> SpringBoot (Scala), FastAPI, PHP, REST</li>
              <li><strong>Frontend:</strong> Angular, VueJS, jQuery, R/Shiny</li>
              <li><strong>Datenbanken:</strong> PostgreSQL, MySQL, Oracle</li>
              <li><strong>Architektur:</strong> Microservices, Verteilte Systeme</li>
              <li><strong>Sprachen:</strong> Python, Java/Scala, JS/TS, R</li>
            </ul>
          </div>

          <!-- Data Engineering & Pipelines -->
          <div class="col-sm-6 wow fadeIn" data-wow-delay="0.8s">
            <hr class="line black">
            <h3 class="text-center">
              <i class="fa fa-database dev-bullets" aria-hidden="true" />
              Data Engineering & Pipelines
            </h3>
            <ul class="list-unstyled small">
              <li><strong>Extraktion:</strong> TIKA, Tesseract (RabbitMQ System)</li>
              <li><strong>Visualisierung:</strong> Streamlit, R/Shiny, Data-Viz</li>
              <li><strong>Modellierung:</strong> PostgresDB-Schema, Zeitreihen</li>
              <li><strong>Tooling:</strong> SPOTPY (Optimierung), Matlab</li>
            </ul>
          </div>
        </div>
      </div>
    </section>



    <!--Über mich-->
    <section
      id="about"
      class="pad-lg"
    >
      <div class="container">
        <div class="row margin-40">
          <div class="col-sm-8 col-sm-offset-2 text-center">
            <h2 class="white">
              Über mich
            </h2>
            <p class="white" />
          </div>
        </div>

        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="1s"
          >
            <br>
            
            <ul class="list-unstyled about-table text-center">
              <li class="headline">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/benjamin-m-91aa4a108/"
                >
                  <h2 class="white">
                    <vue-avatar
                      :username="'Franck Zappatta'"
                      src="img/AVATAR2.jpeg"
                    /> 
                    <span
                      style="display: inline-block;
    margin: -31px 0 0px 12px;
    position: relative;"
                    >Benjamin </span>
                  </h2>
                </a>
              </li>
              <li class="price">
                <h5 class="amount">
                  Informatiker, Mathematiker
                </h5>
              </li>
              <li class="features">
                {{ new Date().getFullYear() - 2016}} Jahre (seit 2016) im Bereich der Webentwicklung tätig
              </li>
              <li class="features">
                {{ new Date().getFullYear() - 2020}} Jahre (seit 2020) Data und Software Engineer bei einem weltweit führenden Unternehmensberatungs- und Technologiedienstleistern.
              </li>
              <li class="features first">
                <strong class="d-block mb-2">DevOps & Engineering</strong>
                <small>
                  Docker, Docker-Compose, AWS, GitHub Actions, GitLab CI, Terraform, RabbitMQ, Kafka, Selenium, PyTest...
                </small>
              </li>
              <li class="features">
                <strong class="d-block mb-2">KI / AI & Machine Learning</strong>
                <small>
                  Computer Vision (YOLOv5), NLP (Spacy, HuggingFace), Time Series (R), Scikit-Learn, TIKA, Tesseract...
                </small>
              </li>
              <li class="features">
                <strong class="d-block mb-2">Full-Stack & Softwareentwicklung</strong>
                <small>
                  SpringBoot, FastAPI, PHP, Angular, VueJS, PostgreSQL, Microservices, Python, Java, JS/TS...
                </small>
              </li>
              <li class="features last btn btn-secondary btn-wide">
                <a href="#invite">Anfrage schicken</a>
              </li>
            </ul>
          </div>
        </div>
        </div>
      </section>

    <section
      id="past-project"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="0.6s"
          >
            <h2 id="letzte-projekte">Letzte Projekte</h2>
          </div>
        </div>
        <div
          class="wow  fadeInUp"
          data-wow-delay="1s"
        >
          <carousel
            :per-page="1"
            :loop="true"
            :autoplay-timeout="6000" 
            direction="up"
            :autoplay="true"
            @pageChange="onPageChange"
          >
            <slide
              v-for="(projekt, index) in projekte"
              :key="index"
            >
              <a
                target="_blank"
                :href="projekt.url || '#'"
              >
                <img
                  class="shadowed_images"
                  :src="projekt.bild"
                  :alt="projekt.titel"
                >
              </a>
            </slide>
          </carousel>
          <br>

          <div
            v-if="projekte[currentSlide]"
            class="row project-info text-center"
          >
            <div class="col-sm-8 col-sm-offset-2">
              <h3>
                <a
                  v-if="projekte[currentSlide].url"
                  :href="projekte[currentSlide].url"
                  target="_blank"
                  style="color: #419f8a;"
                >{{ projekte[currentSlide].titel }}</a>
                <span v-else>{{ projekte[currentSlide].titel }}</span>
              </h3>
              <p>{{ projekte[currentSlide].text }}</p>
            </div>
          </div>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
    </section>


    <section
      id="invite"
      class="pad-lg light-gray-bg"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 text-center">
            <i class="fa fa-envelope-o margin-40" />
            <h2 class="black">
              Schreiben Sie mir eine Anfrage
            </h2>
            <br>
            <p
              class="black"
            >
              Ich bin gespannt auf Ihre Ideen und schicke Ihnen ein auf Ihre Wünsche zugeschnittenes Angebot zu.
            </p>
            <br>

            <Contact />
          </div>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="row margin-40">
        <div class="col-sm-8 col-sm-offset-2 text-center">
          <h2 class="white">
            Weiteres
          </h2>
            
          <p class="white">
            <ul />
          </p>
        </div>
      </div>

      <div class="row">
        <div />
      </div>
    </div>
    
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-8 margin-20">
            <ul class="list-inline social">
              <li>
                <a
                  href="https://github.com/bees4ever"
                  title="GitHub @bees4ever"
                  target="_blank"
                  style="color: #419f8a;"
                >
                  <svg
                    height="20"
                    class="octicon octicon-mark-github d-block"
                    alt="GitHub"
                    viewBox="0 0 16 16"
                    version="1.1"
                    width="20"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/benjamin-manns-91aa4a108/"
                  target="_blank"
                  style="color: #419f8a;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8 margin-20">
            <ul class="list-inline social">
              <li>
                <a
                  class="clickable"
                  @click="show('impressum')"
                >Impressum</a>
              </li>
              <li>
                <a
                  class="clickable"
                  @click="show('privacy')"
                >Datenschutz</a>
              </li>
            </ul>
          </div>

          <div class="col-sm-4 text-right">
            <p>
              <small>
                Copyright &copy; {{ (new Date()).getFullYear() }}. All rights reserved.
                <br>
              </small>
            </p>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
// @ is an alias to /src
import Contact from "@/components/Contact.vue";
import CookieDialog from "@/components/CookieDialog.vue";
import ModalBasic from "@/components/ModalBasic.vue";
import Impressum from "@/components/Impressum.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import MainTopNavBar from "@/components/MainTopNavBar.vue";
import VueAvatar from '@lossendae/vue-avatar'

export default {
  name: "Home",
  components: {
    Contact,
    ModalBasic,
    Impressum,
    PrivacyPolicy,
    MainTopNavBar,
    VueAvatar,
    CookieDialog
  },
  data() {
    return {
      modal_show: {
        impressum: false,
        privacy: false,
        cookie_banner: true
      },
      currentSlide: 0,
      projekte: [
        {
          titel: 'Grün & Gepflegt',
          url: 'https://gruen-gepflegt.de/',
          bild: 'img/projects/gruengepflegt.jpg',
          text: 'Grün & Gepflegt ist ein Wiesbadener Garten- und Landschaftsbauunternehmen von Timon Drebert. Das Angebot umfasst das volle Spektrum an Outdoor-Dienstleistungen — von der privaten Gartenpflege bis zum gewerblichen Landschaftsbau. Das Unternehmen brauchte einen professionellen Webauftritt, um lokale Kunden zu erreichen, sein Leistungsportfolio zu präsentieren und Kontaktanfragen zu generieren.'
        },
        {
          titel: 'Käfolution',
          url: 'https://kaefolution.gardsfabriken.de/',
          bild: 'img/projects/kaefolution.png',
          text: 'Käfolution ist ein interaktives, webbasiertes Lernspiel, das für die Justus-Liebig-Universität Gießen (JLU) entwickelt wurde. Das Spiel vermittelt Studierenden evolutionäre Biologie, natürliche Selektion und Mutation durch anschauliche Simulationen. Spieler beobachten und manipulieren Käferpopulationen, passen Umweltfaktoren an und sehen in Echtzeit, wie Merkmale wie Geschwindigkeit, Größe und Tarnung das Überleben über Generationen beeinflussen.'
        },
        {
          titel: 'Hausaufgaben-Abgabesystem',
          url: 'https://feedback.mni.thm.de/',
          bild: 'img/projects/feedbacksystem.png',
          text: 'Das Hausaufgaben-Abgabesystem ist eine webbasierte Plattform, die für die TH Mittelhessen (Fachbereich MNI) entwickelt wurde. Sie vereinfacht die Einreichung, Bewertung und Rückmeldung von Studienleistungen. Dozenten können Aufgaben erstellen, Fristen setzen und digital Feedback geben — Studierende laden ihre Arbeiten über eine übersichtliche Oberfläche hoch. Das System ersetzt das Chaos von E-Mail-Einreichungen durch einen zentralen, strukturierten Workflow.'
        },
        {
          titel: 'Interaktive VR-Geo-App',
          url: null,
          bild: 'img/projects/geoapp.png',
          text: 'Eine interaktive Virtual-Reality-Anwendung, die Geodaten zum Leben erweckt. Nutzer erkunden 3D-Geländemodelle, navigieren durch Landschaften und interagieren mit georeferenzierten Datenpunkten in einer immersiven VR-Umgebung. Als Bildungsinstrument konzipiert, macht die App Geografie greifbar — Studierende können topografische Karten buchstäblich "durchwandern" und räumliche Zusammenhänge erleben.'
        },
        {
          titel: 'Selective',
          url: null,
          bild: 'img/projects/selective.png',
          text: '"Selective" ist ein browserbasiertes Lernspiel, das Evolutionsbiologie durch Simulation vermittelt. Spieler tauchen in ein virtuelles Ökosystem ein, in dem sie Umweltfaktoren wie Temperatur, Fressfeinde und Nahrungsangebot manipulieren und beobachten, wie sich Populationen über Generationen anpassen. Das Spiel macht abstrakte Konzepte wie Mutation, natürliche Selektion und Gendrift in Echtzeit sichtbar.'
        },
        {
          titel: 'News-Agent',
          url: null,
          bild: 'img/projects/news_agent.png',
          text: 'Deutschlands führende Tageszeitung *Der Tagesspiegel* versendet täglich einen Newsletter mit Dutzenden von Artikeln. Das manuelle Lesen, Bewerten und Teilen der relevantesten Inhalte mit einem Team ist zeitaufwendig und inkonsistent. Die Herausforderung: **Die gesamte Kuration automatisieren** — von der E-Mail-Annahme über die intelligente Auswahl bis hin zur Multi-Channel-Distribution — und das alles ohne manuelles Eingreifen.'
        }
      ]
    };
  },
  methods: {
    show(type) {
      this.modal_show[type] = true;
    },
    close(type) {
      this.modal_show[type] = false;
    },
    onPageChange(index) {
      this.currentSlide = index;
    }
  }
};
</script>


<style scoped>
.dev-bullets{
font-size: 40px;
margin: 4px 5px;
position: relative;
}
.clickable {
  cursor: pointer;
}
.shadowed_images {
  max-width: 100%;

    margin-left: auto;
    margin-right: auto;

    display: block;

  /*margin-left: 10%;*/
  /*-webkit-box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);*/
}
@media only screen and (max-width: 400px) {
  .lead {
    margin-left: 0;
  }
  .webhosting_img {
    width: 320px;
  }
  .top_logo {
    background: black;
    width: 100%;
  }
}
.d-block {
  display: block;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
</style>
